import React from "react"
import {
    ContentfulRichTextGatsbyReference,
    renderRichText,
    RenderRichTextData,
} from "gatsby-source-contentful/rich-text"
import { BLOCKS, MARKS, INLINES } from "@contentful/rich-text-types"
import { Options } from "@contentful/rich-text-react-renderer"
import { Bold, Heading1, Heading2, Text } from "./Markdown"
import { FiExternalLink } from 'react-icons/fi'
type BlogBodyProps = {
    content: RenderRichTextData<ContentfulRichTextGatsbyReference>
}

export const RichText = ({ content, faqComponent }) => {
    const options: Options = {
        renderMark: {
            [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
            [MARKS.ITALIC]: (text) => {
                return <em>{text}</em>
            },
        },
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data
                return (
                    uri.split('/')[2] === 'ekaterratea.com' || faqComponent ? (<a href={uri} target="_blank" rel="noopener noreferrer" aria-label="Link opens in a new window" title="Link opens in a new window">
                        {children} </a>)
                        :
                        (<a href={uri} target="_blank" rel="noopener noreferrer" aria-label="Link opens in a new window" title="Link opens in a new window">
                            <span> <FiExternalLink /> </span>  {children} </a>)
                )
            },

            [BLOCKS.HEADING_1]: (node, children) => <Heading1>{children}</Heading1>,
            [BLOCKS.HEADING_2]: (node, children) => <Heading2>{children}</Heading2>,
            [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
        },
    }
    if (content && content.raw) {
        return (
            <article className="blog-body">{renderRichText(content, options)}</article>
        )
    }
    else{
        return(
            <div></div>
        )
    }
}